<div class="toolbar-button container {{color}}" fxLayoutAlign="center center" matRipple [matRippleDisabled]="disabled"
     [ngClass]="{disabled: disabled}" (click)="handleClick($event)">
  <fa-icon class="primary-icon" [icon]="icon"></fa-icon>
  <div class="color-bar"></div>
  <div class="disabled-overlay" *ngIf="disabled" mtnClickTrap></div>
</div>
